import { ApiResponse, CustomQueryResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";

const SERVICE_URL = ServiceEndPoint.outbound_service;
const ACCOUNT_SERVICE_URL = ServiceEndPoint.account_service;

export async function fetchAllocationPlan(payload?: any): Promise<ApiResponse<CustomQueryResponse<any>>> {
       const response = await axiosService.post(`${SERVICE_URL}allocation-plans/query`, payload);
       return response.data;
}

export async function getAllocationPlanDetails(id:string): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}allocation-plans/${id}`);
    return response.data;
}

export async function fetchAllocationPlanConditionColumn(): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}lookup/allocation_configs.condition_columns`);
    return response.data;
}

export async function fetchAllocationPlanOrderByColumn(): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}lookup/allocation_configs.order_bys`);
    return response.data;
}

export async function fetchInventoryStatusLookup(): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}lookup/inventories.status`);
    return response.data;
}

export async function submitAllocationPlanForm(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${SERVICE_URL}allocation-plans`,payload);
    return response.data;
}

export async function updateAllocationPlanForm(payload:any,id?:string): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}allocation-plans/${id}`,payload);
  return response.data;
}
export async function deleteAllocationPlanById(id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}allocation-plans/${id}`);
  return response.data;
}